import { Link } from "react-router-dom";

const statusStyles = {
  green: "bg-green-100 text-green-800 hover:bg-green-700 hover:text-white",
  yellow: "bg-yellow-100 text-yellow-800 hover:bg-yellow-400 hover:text-white",
  red: "bg-red-100 text-red-800 hover:bg-red-700 hover:text-white",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Agents({ filterdAgents }) {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-4 px-8 align-middle">
            <div className="shadow-sm ring-1 ring-black ring-opacity-5">
              <div>
                <div className="grid lg:grid-cols-4 grid-cols-3 bg-gray-50">
                  <span className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8">
                    Name
                  </span>
                  <span className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                    Phone Number
                  </span>
                  <span className="sticky top-0 z-10 hidden border-b border-gray-300 bg-gray-50 bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter lg:block">
                    Address
                  </span>
                  <span className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                    Loan Status
                  </span>
                </div>
                <div className="bg-white">
                  {filterdAgents.map((agent, agentIdx) => (
                    <div key={agent.attributes.address}>
                      <Link
                        to={`/manager/agent/${agent.id}`}
                        className="grid lg:grid-cols-4 grid-cols-3 hover:bg-gray-100 border border-gray-200"
                      >
                        <span
                          className={classNames(
                            "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8"
                          )}
                        >
                          {agent.attributes.name}
                        </span>
                        <span
                          className={classNames(
                            "whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                          )}
                        >
                          {agent.attributes.phoneNo}
                        </span>
                        <span
                          className={classNames(
                            "whitespace-nowrap px-3 py-4 text-sm text-gray-500 hidden lg:table-cell"
                          )}
                        >
                          {agent.attributes.address}
                        </span>
                        <span
                          className={classNames(
                            statusStyles[agent.attributes.loanStatus],
                            "inline-flex items-center px-2.5 my-1.5 mr-2 rounded-md text-xs font-medium capitalize"
                          )}
                        >
                          {agent.attributes.loanStatus}
                        </span>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
